import React, { Component } from 'react';
import _ from 'lodash';
import Charts from '../../common/Charts'
import { Row, Col, Card, Spin } from 'antd';
class CardioVascularDiseases extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            cvdOverall: {filters:[], config:{}},
            cvdGender: {filters:[], config:{}},
            cvdLocation: {filters:[], config:{}},
            cvdCompany: {filters:[], config:{}},
            baseConfig : {
              filters: [],
              config: {
                  chart: {
                      renderTo: 'container',
                      type: 'column'
                  },
                  title: {
                      text: 'CVD',
                      align: 'left',
                      margin: 35
                  },
                  subtitle: { text: '', align: '' },
                  xAxis: {},
                  yAxis: {title: {text: 'Moderate/High Risk in %'}, 
                    labels: {
                      formatter: function() {
                        return this.value + ' %';
                      }
                    },
                    max: 100
                  },
                  plotOptions: {
                    series: {
                      stacking: 'normal'
                    }
                  },
                  credits: {
                    enabled: false
                  },
                  series: []
              }
            }
        };
        this.cvdLocCallback = this.cvdLocCallback.bind(this)
        this.cvdGenderCallback = this.cvdGenderCallback.bind(this)
        this.cvdCompanyCallback = this.cvdCompanyCallback.bind(this)
    }
    componentWillMount () {
      this.getCVDOverall()
      this.getCVDGender()
      this.getCVDLocation()
      this.getCVDCompany()    
    }

    getCVDCompany () {
      let that = this;
      let baseConfig = _.cloneDeep(this.state.baseConfig)
      this.setState({loading: true})
      baseConfig.config.subtitle.text = 'Industry wise distribution'
      window.axios.get(window.API_URL + 'corporate/dashboard/cvd-trends/company-wise')
      .then(function (response) {
        baseConfig.filters = response.data.filters
        let series = response.data.series.find( object => object.filter === response.data.filters[0] );
        baseConfig.config.series = series.series
        baseConfig.config.xAxis = series.xAxis
        // baseConfig.config.yAxis = series.yAxis
        let a = series.series
        if (a.length > 0){
          let b = a.map(a => a.data)
          // b = b.flat()  only supports latest browsers
          b = Array.prototype.concat(...b)
          b = b.filter( item => item ) // this will delete undefined from array
          if (b.length > 0){
            baseConfig.config.yAxis["max"] = Math.max(...b)
          }
        }
        baseConfig.config.plotOptions = {column: {maxPointWidth: 31}}
        that.setState({cvdCompany: baseConfig, allCVDCompany: response.data, loading: false})
      })
      .catch(function (error) {
        console.log(error);
        this.setState({loading: false})
      })
    }

    cvdCompanyCallback(filter) {
      let series = this.state.allCVDCompany.series.find( object => object.filter === filter );
      let baseConfig = _.cloneDeep(this.state.baseConfig)
      baseConfig.filters = this.state.allCVDCompany.filters
      baseConfig.config.subtitle.text = 'Industry wise distribution'
      baseConfig.config.series = series.series
      baseConfig.config.xAxis = series.xAxis
      // baseConfig.config.yAxis = series.yAxis
      let a = series.series
        if (a.length > 0){
          let b = a.map(a => a.data)
          // b = b.flat()  only supports latest browsers
          b = Array.prototype.concat(...b)
          b = b.filter( item => item ) // this will delete undefined from array
          if (b.length > 0){
            baseConfig.config.yAxis["max"] = Math.max(...b)
          }
        }
      baseConfig.config.plotOptions = {column: {maxPointWidth: 31}}
      this.setState({cvdCompany: baseConfig})
    }

    getCVDLocation () {
      let that = this;
      let baseConfig = _.cloneDeep(this.state.baseConfig)
      this.setState({loading: true})
      baseConfig.config.subtitle.text = 'Location, Department & Shift wise distribution'
      window.axios.get(window.API_URL + 'corporate/dashboard/cvd-trends/other-trends')
      .then(function (response) {
        baseConfig.filters = response.data.filters
        let series = response.data.series.find( object => object.filter === response.data.filters[0] );
        baseConfig.config.series = series.series
        baseConfig.config.xAxis = series.xAxis
        // baseConfig.config.yAxis = series.yAxis
        let a = series.series
        if (a.length > 0){
          let b = a.map(a => a.data)
          // b = b.flat()  only supports latest browsers
          b = Array.prototype.concat(...b)
          b = b.filter( item => item ) // this will delete undefined from array
          if (b.length > 0){
            baseConfig.config.yAxis["max"] = Math.max(...b)
          }
        }
        baseConfig.config.plotOptions = {column: {maxPointWidth: 31}}
        that.setState({cvdLocation: baseConfig, allCVDLoc: response.data, loading: false})
      })
      .catch(function (error) {
        console.log(error);
        this.setState({loading: false})
      })
    }
    cvdLocCallback (filter) {
      let series = this.state.allCVDLoc.series.find( object => object.filter === filter );
      let baseConfig = _.cloneDeep(this.state.baseConfig)
      baseConfig.filters = this.state.allCVDLoc.filters
      baseConfig.config.subtitle.text = 'Location, Department & Shift wise distribution'
      baseConfig.config.series = series.series
      baseConfig.config.xAxis = series.xAxis
      // baseConfig.config.yAxis = series.yAxis
      let a = series.series
        if (a.length > 0){
          let b = a.map(a => a.data)
          // b = b.flat()  only supports latest browsers
          b = Array.prototype.concat(...b)
          b = b.filter( item => item ) // this will delete undefined from array
          if (b.length > 0){
            baseConfig.config.yAxis["max"] = Math.max(...b)
          }
        }
      baseConfig.config.plotOptions = {column: {maxPointWidth: 31}}
      this.setState({cvdLocation: baseConfig})
    }

    getCVDGender () {
      let that = this;
      let baseConfig = _.cloneDeep(this.state.baseConfig)
      this.setState({loading: true})
      baseConfig.config.subtitle.text = 'Gender wise distribution'
      window.axios.get(window.API_URL + 'corporate/dashboard/cvd-trends/age-gender')
      .then(function (response) {
        baseConfig.filters = response.data.filters
        let series = response.data.series.find( object => object.filter === response.data.filters[0] );
        baseConfig.config.series = series.series
        baseConfig.config.xAxis = series.xAxis
        // baseConfig.config.yAxis = series.yAxis
        let a = series.series
        if (a.length > 0){
          let b = a.map(a => a.data)
          // b = b.flat()  only supports latest browsers
          b = Array.prototype.concat(...b)
          b = b.filter( item => item ) // this will delete undefined from array
          if (b.length > 0){
            baseConfig.config.yAxis["max"] = Math.max(...b)
          }
        }
        baseConfig.config.plotOptions = {column: {maxPointWidth: 31}}
        that.setState({cvdGender: baseConfig, allCVDGender: response.data, loading: false})
      })
      .catch(function (error) {
        console.log(error);
        this.setState({loading: false})
      })
    }
    cvdGenderCallback(filter) {
      let series = this.state.allCVDGender.series.find( object => object.filter === filter );
      let baseConfig = _.cloneDeep(this.state.baseConfig)
      baseConfig.filters = this.state.allCVDGender.filters
      baseConfig.config.subtitle.text = 'Gender wise distribution'
      baseConfig.config.series = series.series
      baseConfig.config.xAxis = series.xAxis
      // baseConfig.config.yAxis = series.yAxis
      let a = series.series
      if (a.length > 0){
        let b = a.map(a => a.data)
        // b = b.flat()  only supports latest browsers
          b = Array.prototype.concat(...b)
        b = b.filter( item => item ) // this will delete undefined from array
        if (b.length > 0){
          baseConfig.config.yAxis["max"] = Math.max(...b)
        }
      }
      baseConfig.config.plotOptions = {column: {maxPointWidth: 31}}
      this.setState({cvdGender: baseConfig})
    }

    getCVDOverall () {
        let that = this
        let baseConfig = {
          filters: [],
          config: {
            chart: {
                plotBackgroundColor: null,
                plotBorderWidth: null,
                plotShadow: false,
                type: 'pie'
            },
            title: {
                text: 'CVD',
                align: 'left'
            },
            subtitle: {
                text: '',
                align: 'left'
            },
            tooltip: {
                pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
            },
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: true,
                        distance: 20,
                        format: '{point.percentage:.1f} %',
                        style: {
                            color: 'black'
                        },
                        connectorColor: 'silver'
                    },
                    showInLegend: true
                }
            },
            credits: {
              enabled: false
            },
            series: [{
                name: 'Employees',
                data: []
            }]
          }
        }
        window.axios.get(window.API_URL + 'corporate/dashboard/cvd-trends/overall')
        .then(function (response) {
          baseConfig.config.series[0].data = response.data.series
          baseConfig.config.subtitle.text = response.data.total_count + " Users"
          that.setState({cvdOverall: baseConfig})
        })
        .catch(function (error) {
          console.log(error);
        })
    }
    render () {
        return (
            <div className="gutter-example">
              <Spin spinning={this.state.loading}>
                <Card>
                  <Row gutter={16}>
                      <Col className="gutter-row" span={11}>
                          <div className="gutter-box">
                              <Charts filters={this.state.cvdOverall.filters} config={this.state.cvdOverall.config}/>
                          </div>
                      </Col>
                      <Col span={2}/>
                      <Col className="gutter-row" span={11}>
                          <div className="gutter-box">
                              <Charts callback={this.cvdGenderCallback}
                              filters={this.state.cvdGender.filters} 
                              config={this.state.cvdGender.config}/>
                          </div>
                      </Col>
                  </Row>
                </Card>  
                  <br></br>
                <Card>
                  <Row gutter={16}>
                      <Col className="gutter-row" span={11}>
                          <div className="gutter-box">
                              <Charts callback={this.cvdLocCallback}
                              filters={this.state.cvdLocation.filters} 
                              config={this.state.cvdLocation.config}/>
                          </div>
                      </Col>
                      <Col span={2}/>
                      <Col className="gutter-row" span={11}>
                          <div className="gutter-box">
                              <Charts callback={this.cvdCompanyCallback}
                              filters={this.state.cvdCompany.filters} 
                              config={this.state.cvdCompany.config}/>
                          </div>
                      </Col>
                  </Row>
                </Card>  
                <br></br>
              </Spin>  
            </div>
        )
    }
}
export default CardioVascularDiseases;